// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2veRq","title":"card_title__2iZZG","inActive":"card_inActive__2XQzJ"};